import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { locales } from '../data/translations';
type LanguageSwitcherProps = {
  className?: string;
};

/**
 * Segmented EN / ES language switcher. The active pill slides between options
 * with a shared layout animation (transform only).
 */
export function LanguageSwitcher({
  className = ''
}: LanguageSwitcherProps) {
  const {
    locale,
    setLocale,
    t
  } = useLanguage();
  return <div role="group" aria-label={t.language.label} className={`inline-flex items-center gap-0.5 rounded-full border border-white/15 bg-white/5 p-1 backdrop-blur-md ${className}`} data-id="element-119" data-mp="4gsamcre04kf">
      {locales.map(option => {
      const isActive = option.code === locale;
      return <button key={option.code} type="button" lang={option.code} onClick={() => setLocale(option.code)} aria-pressed={isActive} aria-label={option.name} className={`relative rounded-full px-3 py-1.5 text-[0.7rem] font-extrabold uppercase tracking-[0.14em] transition-colors duration-200 ${isActive ? 'text-white' : 'text-white/55 hover:text-white'}`} data-id="element-120" data-mp="i8gpgnt0t753">
            {isActive && <motion.span layoutId="language-pill" transition={{
          type: 'spring',
          stiffness: 420,
          damping: 32
        }} className="absolute inset-0 rounded-full bg-magenta shadow-glow-magenta" data-id="element-121" data-mp="1ynikqjcrg4bk" />}
            <span className="relative" data-id="element-122" data-mp="2re0ntkdhi5oz">{option.label}</span>
          </button>;
    })}
    </div>;
}